window.is_ie = /MSIE|Trident/i.test(navigator.userAgent);
window.is_iphone = /iPhone|iPod/i.test(navigator.userAgent);
window.is_touch_device = 'ontouchstart' in document.documentElement;
California.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();
California.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

California.Sections.prototype = _.assignIn({}, California.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

California.Currency = (function() {
  var moneyFormat = '$';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();
California.Disclosure = (function() {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};
    this._cacheSelectors();
    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }

  Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions)
      };
    },

    _connectToggle: function() {
      this.cache.$disclosureToggle.on(
        'click',
        function(evt) {
          var ariaExpanded =
            $(evt.currentTarget).attr('aria-expanded') === 'true';
          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this)
      );
    },

    _connectOptions: function() {
      this.cache.$disclosureOptions.on(
        'click',
        function(evt) {
          this._submitForm($(evt.currentTarget).data('value'));
        }.bind(this)
      );
    },

    _onFocusOut: function() {
      this.cache.$disclosureToggle.on(
        'focusout',
        function(evt) {
          var disclosureLostFocus =
            this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.cache.$disclosureList.on(
        'focusout',
        function(evt) {
          var childInFocus =
            $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.$container.on(
        'keyup',
        function(evt) {
          if (evt.which !== 27) return;
          this._hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this)
      );

      $('body').on(
        'click',
        function(evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this)
      );
    },

    _submitForm: function(value) {
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
    },

    _hideList: function() {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureToggle.attr('aria-expanded', false);
    },

    unload: function() {
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    }
  });

  return Disclosure;
})();
California.Hero = (function() {

  var $hero, 
      $slides,
      $hero_slides,
      $hero_slide,
      $hero_text,
      $window;

  function Hero(container) {
    $hero = $(container);
    $slides = $('.slides', $hero);
    $hero_slide = $('.slide', $hero);
    $hero_text = $('.content .container', $hero);
    $window = $(window);

    if ($hero_slide.length > 1) {
      $slides.slick({
        arrows: $slides.data('arrows'),
        dots: $slides.data('dots'),
        pauseOnHover: false,
        fade: $slides.data('use-fade'),
        autoplay: $slides.data('autoplay'),
        autoplaySpeed: $slides.data('speed') * 1000,
        easing: 'easeInOutQuad',
        speed: 1200,
        focusOnChange: false,
        accessibility: true
      });

      $slides.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        if ($hero.hasClass('with-parallax')) {
          $window.trigger('scroll.parallax');
        }
      });
    }

    // parallax
    if ($hero.hasClass('with-parallax')) {
      $window.on('scroll.parallax', function(e){
        var scrolled = $window.scrollTop();
        $('.slick-slide', $hero).css('transform', 'translate3d(0, ' + scrolled / 4.5 + 'px, 0)');
        $('.content .container', $hero).css('transform', 'translate3d(0, ' + scrolled / 20 + 'px, 0)');
      }).trigger('scroll.parallax');
    } else {
      $window.off('scroll.parallax');
    }

    // min height
    var setHeroMinHeight = function(){
      var min_height = $('.content .inner .container', $hero).outerHeight(true);
      $hero.css('min-height', min_height);
    };

    setHeroMinHeight();

    $window.on('resize', function(){
      setHeroMinHeight();
    });

    if($('.logo img', $hero).length > 0){
      var image = new Image();
      image.onload = function(){
        setHeroMinHeight();
      }
      image.src = $('.logo img', $hero).attr('src');
    }
  }

  Hero.prototype = _.assignIn({}, Hero.prototype, {
    onDeselect: function(event) {
      if ($slides.data('autoplay')) {
        $slides.slick('slickPlay');
      }
    },
    onBlockSelect: function(event) {
      var $target = $(event.target);
      $slides.slick('slickPause');
      $slides.slick('slickGoTo', $target.data('index'), true);
    },
    onBlockDeselect: function(event) {
      this.onDeselect(event);
    }
  });

  return Hero;
})();

California.FeaturedCollection = (function() {

  function FeaturedCollection(container) {
    $(document).trigger('products_rendered');
  }

  return FeaturedCollection;
})();

California.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();
// Youtube API callback
function onYouTubeIframeAPIReady() {
  California.ProductVideo.loadVideos(California.ProductVideo.hosts.youtube);
}

California.ProductVideo = (function() {
  var videos = {};

  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };

  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer.length) {
      return;
    }

    var videoElement = videoContainer.find('iframe, video')[0];
    var mediaId = videoContainer.data('mediaId');

    if (!videoElement) {
      return;
    }

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    var video = videos[mediaId];

    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '1.0',
            onLoad: setupPlyrVideos
          }
        ]);
        California.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        California.LibraryLoader.load('youtubeSdk');
        break;
    }
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }

    loadVideos(hosts.html5);
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );
    var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

    switch (video.host) {
      case hosts.html5:
        video.player = new Shopify.Plyr(video.element, {
          controls: [
            'play',
            'progress',
            'mute',
            'volume',
            'play-large',
            'fullscreen'
          ],
          loop: { active: enableLooping },
          hideControlsOnPause: true,
          iconUrl:
            '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
          tooltips: { controls: false, seek: true }
        });
        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.data(attributes.videoId);
        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function(event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
              if (event.data === 1) productMediaWrapper.trigger('playing');
            }
          }
        });
        break;
    }

    productMediaWrapper.on('mediaHidden xrLaunch', function() {
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.pause();
      }
      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();
      }
    });


    productMediaWrapper.on('mediaVisible', function() {
      if (window.is_touch_device) return;
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.play();
      }
      if (video.host === hosts.youtube && video.player.playVideo) {
        video.player.playVideo();
      }
    });
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }
    if (video.tagName === 'IFRAME') {
      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          video.src
        )
      ) {
        return hosts.youtube;
      }
    }
    return null;
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.nativeVideo) continue;

        if (video.host === hosts.html5) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();
California.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.each(function(index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data('media-id');
      var $modelViewerElement = $(
        $modelViewerContainer.find('model-viewer')[0]
      );
      var modelId = $modelViewerElement.data('model-id');

      if (index === 0) {
        var $xrButton = $modelViewerContainer
          .closest(selectors.mediaGroup)
          .find(selectors.xrButton);
        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);

    California.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) {
      return;
    }
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var $modelJson = $('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) {
      return;
    }
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];
    model.$container.on('mediaVisible', function() {
      xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
      if (window.is_touch_device) return;
      model.modelViewerUi.play();
    });
    model.$container
      .on('mediaHidden', function() {
        xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      })
      .on('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();
California.Product = (function() {

  function Product(container) {
    var $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id'),
        self = this;

    this.$item = $('.item', $container);
    this.$info = $('.info', $container);
    this.$window = $(window);
    this.$footer = $('.footer');

    this.selectors = {
      originalSelectorId: '#productSelect-' + sectionId,
      addToCart: '#addToCart-' + sectionId,
      productPrice: '#productPrice-' + sectionId,
      comparePrice: '#comparePrice-' + sectionId,
      unitPrice: '#unitPrice-' + sectionId,
      productStock: '#productStock-' + sectionId,
      productQuantity: '#productQuantity-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId
    };

    this.settings = {
      sectionId: sectionId,
      enableHistoryState: $container.data('enable-history-state') || true,
      namespace: '.product-' + sectionId
    };

    // Stop parsing if we don't have the product json script tag
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($('#ProductJson-' + sectionId).html());

    this.init();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this.initStoreAvailability();
      this.initVariants();
      this.initImageZoom();
      this.initScrollEffect();
      this.initMediaGallery();
      this.initMediaStack();
      this.initProductVideo();
      this.initProductModel();
      this.initShopifyXrLaunch();
    },
    initStoreAvailability: function() {
      var $storeAvailabilityContainer = $(
        '[data-store-availability-container]',
        this.$container
      );
      if ($storeAvailabilityContainer.length < 1) return;
      this.storeAvailability = new California.StoreAvailability(
        $storeAvailabilityContainer[0]
      );
    },
    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId
      };

      this.variants = new California.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this.updateAddToCartButton.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrices.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateMedia.bind(this));

      if (this.storeAvailability) {
        this.storeAvailability.updateContent(
          this.variants ? this.variants.currentVariant : this.productSingleObject.variants[0]
        );
      }
    },
    updateAddToCartButton: function(event){
      var variant = event.variant;

      var cache = {
        $stock: $(this.selectors.productStock),
        $quantity: $(this.selectors.productQuantity),
        $addToCart: $(this.selectors.addToCart)
      };

      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          // We have a valid product variant, so enable the submit button
          cache.$addToCart.removeClass('disabled').prop('disabled', false).val(cache.$addToCart.data('value'));
        } else {
          // Variant is sold out, disable the submit button
          cache.$addToCart.val(California.strings.sold_out).addClass('disabled').prop('disabled', true);
        }

        // Update inventory tracking if it's setup
        if (variant.inventory_management == 'shopify') {
          variant.inventory_quantity = window.inventory[variant.id];
          cache.$stock.removeClass('hide').find('span.units').html(variant.inventory_quantity);
          if (cache.$quantity.length) {
            cache.$quantity.empty();
            for(var i=1; i<=Math.min(variant.inventory_quantity || 50, 50); i++) {
              cache.$quantity.append($("<option></option>").attr("value", i).text(i));
            }
          }
        } else {
          cache.$stock.addClass('hide');
          if (cache.$quantity.length) {
            cache.$quantity.empty();
            for(var i=1; i<=50; i++) {
              cache.$quantity.append($("<option></option>").attr("value", i).text(i));
            }
          }
        }
        // Update store availability
        if (this.storeAvailability) {
          this.storeAvailability.updateContent(
            variant
          );
        }
      } else {
        cache.$addToCart.val(California.strings.unavailable).addClass('disabled').prop('disabled', true);
        if (this.storeAvailability) {
          this.storeAvailability.hide();
        }
      }
    },
    updatePrices: function(event){
      var variant = event.variant;

      if (variant) {
        $(this.selectors.productPrice).html($('<span>').html(California.Currency.formatMoney(variant.price, California.strings.money_format)));

        // Update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $(this.selectors.comparePrice)
            .html($('<span>').html(California.Currency.formatMoney(variant.compare_at_price, California.strings.money_format)))
            .show();
        } else {
          $(this.selectors.comparePrice).hide();
        }

        // And the unit price
        if (variant.unit_price_measurement) {
          unitPrice = '(' + California.Currency.formatMoney(variant.unit_price, California.strings.money_format);
          unitPrice += '/';
          unitPrice += this._getBaseUnit(variant) + ')';
          $(this.selectors.unitPrice).html($('<span>').addClass('unit-price nowrap').html(unitPrice)).show();
        } else {
          $(this.selectors.unitPrice).empty().hide();
        }

      } else {
        $(this.selectors.comparePrice).hide();
        $(this.selectors.unitPrice).empty().hide();
      }
      California.onPriceAdded();
    },
    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },
    updateMedia: function(event){
      var variant = event.variant;

      if (variant) {
        if (variant.featured_image) {
          var id = variant.featured_media.id,
              $newMedia = $('#' + id);

          if($newMedia.length){
            var $thumbnail = $('[data-action=show-product-media][data-id=' + id + ']');
            $newMedia.siblings().addClass('hide').trigger('mediaHidden');
            $newMedia.removeClass('hide').trigger('mediaVisible');
            $thumbnail.parent().siblings().find('.active').removeClass('active');
            $thumbnail.addClass('active');

            if($('.product-media').hasClass('stack') && this.$window.width() > 720) {
              var padding = 15,
                  header_height = 200,
                  offset = $newMedia.offset().top - padding;

              if (offset < header_height){
                offset = 0;
              }

              $('body,html').animate({ scrollTop: offset }, { duration: 600 });
            }
          }
        }
      }
    },
    initMediaGallery: function() {
      var self = this;
      $(document)
        .on('click', '[data-action=show-product-media][data-id]', function(e){
          e.preventDefault();
          var $thumbnail = $(this),
              $newMedia = $('#' + $thumbnail.data('id'));
          $newMedia.siblings().addClass('hide').trigger('mediaHidden');
          $newMedia.removeClass('hide').trigger('mediaVisible');
          $thumbnail.parent().siblings().find('.active').removeClass('active');
          $thumbnail.addClass('active');
        });
    },
    initMediaStack: function() {
      if($('.product-media.stack').length > 0) {
        $('[data-product-single-media-wrapper]').on('playing', function() {
          $(this).siblings().trigger('mediaHidden');
        });
      }
    },
    initImageZoom: function() {
      $('[data-mfp-src]', this.$container).magnificPopup({
        type: 'image',
        mainClass: 'mfp-fade',
        closeOnBgClick: true,
        closeBtnInside: false,
        closeOnContentClick: true,
        tClose: California.strings.zoom_close,
        removalDelay: 500,
        closeMarkup: '<button title="%title%" class="mfp-close"><i class="fc fc-close"></i></button>',
        gallery: {
          enabled:true,
          navigateByImgClick: false,
          arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
          tPrev: California.strings.zoom_previous,
          tNext: California.strings.zoom_next
        }
      });
    },

    initScrollEffect: function() {
      enquire.register("screen and (min-width:720px)", {
        match : function() {
          $('.product img')
            .imagesLoaded()
            .always(function(instance){
              $(".info .inner").stick_in_parent({
                parent: '.item'
              });
            });
        },
        unmatch: function() {
          $(".info .inner").trigger("sticky_kit:detach");
        }
      });
    },

    initProductVideo: function() {
      var sectionId = this.settings.sectionId;
      $('[data-product-media-type-video]', this.$container).each(function() {
        California.ProductVideo.init($(this), sectionId);
      });
    },

    initProductModel: function() {
      var $modelViewerElements = $(
        '[data-product-media-type-model]',
        this.$container
      );
      if ($modelViewerElements.length < 1) return;
      California.ProductModel.init($modelViewerElements, this.settings.sectionId);
    },

    initShopifyXrLaunch: function() {
      var self = this;
      $(document).on('shopify_xr_launch', function() {
        var $currentMedia = $(
          self.selectors.productMediaWrapper +
            ':not(.' +
            self.classes.hidden +
            ')',
          self.$container
        );
        $currentMedia.trigger('xrLaunch');
      });
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      California.ProductVideo.removeSectionVideos(this.settings.sectionId);
      California.ProductModel.removeSectionModels(this.settings.sectionId);
    }
  });

  return Product;
})();

California.StoreAvailability = (function() {

  function StoreAvailability(container) {
    this.container = container;
    this.productTitle = container.dataset.productTitle;
  }

  StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
    updateContent: function(variant) {
      var self = this,
         variantSectionUrl =
          this.container.dataset.baseUrl +
          '/variants/' +
          variant.id +
          '/?section_id=store-availability';

      this.container.innerHTML = '';
      fetch(variantSectionUrl)
        .then(function(response) {
          return response.text();
        })
        .then(function(storeAvailabilityHTML) {
          $('.side-pick').remove();
          self.container.innerHTML = storeAvailabilityHTML;
          self.container.innerHTML = self.container.firstElementChild.innerHTML;
          if($('.side-pick').length > 0) {
            $('[data-store-availability-modal-product-title]').text(self.productTitle);
            $('.side-pick').insertAfter('.side-nav-section');
            if(variant.available){
              self.show();
            } else {
              self.hide();
            }
          }
          if($(self.container).data('has-only-default-variant')){
            $('.side-pick .side-pick-header h3').remove();
          }
        });
    },

    show: function() {
      $('.store-availability').show();
    },

    hide: function() {
      $('.store-availability').hide();
    }
  });

  return StoreAvailability;
})();
California.ProductRecommendations = (function() {

  function ProductRecommendations(container) {
    var self = this;
    self.$container = $(container);
    self.$product_related_products = $('.product-related-products[data-product-id]', this.$container);

    if (self.$product_related_products.length) {
      var productId = this.$product_related_products.data('product-id'),
          limit = this.$product_related_products.data('limit') || 4,
          baseUrl = this.$product_related_products.data('base-url'),
          url = baseUrl + "?section_id=product-recommendations&limit="+limit+"&product_id="+productId;

      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: url,
        success: function(data) {
          var $data = $(data),
              $new_product_related_products = $data.find('.product-related-products')
              $dom_product_related_products = $('.product-related-products', self.$container);
          $dom_product_related_products.replaceWith($new_product_related_products);
        }
      });
    }
  }

  return ProductRecommendations;
})();

California.SideNav = (function() {

  function SideNav(container) {
  }

  SideNav.prototype = _.assignIn({}, SideNav.prototype, {
    onSelect: function(event) {
      if(!$('body').hasClass('browsing')) {
        $('[data-action=toggle-browse]').first().click();
      }
    },
    onDeselect: function(event) {
      if($('body').hasClass('browsing')) {
        $('[data-action=toggle-browse]').first().click();
      }
    }
  });

  return SideNav;
})();

California.Map = (function() {

  var config = {
    zoom: 14,
    styles: [
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }
]
  };
  var apiStatus = null;
  var mapsToLoad = [];

  function Map(container) {
    this.$container = $(container);
    var key = this.$container.data('api-key');

    if (typeof key !== 'string' || key === '') {
      return;
    }

    if (apiStatus === 'loaded') {
      var self = this;

      // Check if the script has previously been loaded with this key
      var $script = $('script[src*="' + key + '&"]');
      if ($script.length === 0) {
        $.getScript(
          'https://maps.googleapis.com/maps/api/js?key=' + key
        ).then(function() {
          apiStatus = 'loaded';
          self.createMap();
        });
      } else {
        this.createMap();
      }
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          })
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-container');

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles,
              center: results[0].geometry.location,
              draggable: true,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: false,
              disableDefaultUI: true,
              zoomControl: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: center
            });

            google.maps.event.addDomListener(window, 'resize', function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
            });
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = California.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = California.strings.addressQueryLimit;
              break;
            default:
              errorMessage = California.strings.addressError;
              break;
          }

          // Only show error in the theme editor
          if (true) {
            $map
              .addClass('error')
              .find('.warning')
              .html(errorMessage);
          }
        });
    },

    onUnload: function() {
      if (typeof window.google !== 'undefined') {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();


California.Footer = (function() {

  function Footer(container) {
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new California.Disclosure(
        this.cache.$localeDisclosure
      );
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new California.Disclosure(
        this.cache.$currencyDisclosure
      );
    }
  }

  Footer.prototype = _.assignIn({}, Footer.prototype, {
    cacheSelectors: function() {
      this.cache = {
        $localeDisclosure: this.$container.find('[data-disclosure-locale]'),
        $currencyDisclosure: this.$container.find('[data-disclosure-currency]'),
        $rte: this.$container.find('.contact p')
      };
    },

    onUnload: function() {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    }
  });

  return Footer;
})();
window.themeInfo = {name: "California"} 

$(document).ready(function() {
  California.initIE();
  California.initEasings();
  California.init();
});

California.init = function(){
  California.initPageConfig();
  California.initListeners();
  California.initHomepage()
  California.initSections();
  California.initLoginPage();
  California.initAddressesPage();
  California.initSearchPage();
  California.initFooter();
  California.initNewsletter();
  $(document).trigger('products_rendered');
};

California.initPageConfig = function(){
  if (window.is_ie) {
    $("html").addClass("ie");
  }
};

California.initListeners = function(){

  $(document)
    .on('click', '[data-action=toggle-search]', function(e){
      e.preventDefault();
      var $body = $('body');
      if($body.hasClass('browsing')){
        $('[data-action=toggle-browse]').first().click();
      } else {
        $body.toggleClass('searching');
        $('.header-nav [data-action=toggle-search]').toggleClass('active');
        if($body.hasClass('searching')){
          $('.search-bar input.query').focus().val('');
        } else {
          $('.search-bar input.query').blur();
        }
      }
    })

    .on('keydown', '[data-action=toggle-search]', function(e) {
      if(e.which == 13){
        e.preventDefault();
        $('[data-action=toggle-search]').first().click();
      }
    })

    .on('click', '[data-action=go-back]', function(e){
      window.history.back();
      e.preventDefault();
    })

    .on('click', '[data-action=toggle-browse]', function(e){
      if ($('body').hasClass('searching')) {
        $('[data-action=toggle-search]').first().click();
      } else {
        if ($('body').hasClass('browsing')) {
          California.closeSideNav();
        } else {
          California.openSideNav();
        }
      }
      e.preventDefault();
    })

    .on('click', '[data-action=toggle-pick]', function(e){
      if ($('body').hasClass('searching')) {
        $('[data-action=toggle-search]').first().click();
      } else {
        if ($('body').hasClass('picking')) {
          California.closeSidePick();
        } else {
          California.openSidePick();
        }
      }
      e.preventDefault();
    })

    .on('click', '.browsing', function(e) {
      e.stopPropagation();
      var $target = $(e.target);
      if (!$target.closest('.side-nav a').length && !$target.closest('[data-action=toggle-browse]').length) {
        California.closeSideNav();
        e.preventDefault();
      }
    })

    .on('click', '.picking', function(e) {
      e.stopPropagation();
      var $target = $(e.target);
      if (!$target.closest('.side-pick a').length && !$target.closest('[data-action=toggle-pick]').length) {
        California.closeSidePick();
        e.preventDefault();
      }
    })

    .on('change', '.tickets .number select', function() {
      return $(this).parent('form').submit();
    })
    
    .on('click', '[data-action=process][data-message]', function(e) {
      var $this = $(this),
          $window = $(window);

      $('<a>').insertAfter($this).attr('class', $this.attr('class') + ' processing').html($this.attr('data-message')).prepend($('<i class="fc fc-cog fc-spin">'));
      $this.hide();
    })

    .on('click', '[data-action=scroll]', function(e) {
      e.preventDefault();
      $('body,html').animate({
        scrollTop:
          $('.hero').height() +
          (window.is_iphone ? 30 : 0) +
          ($('.announcement-bar').length ? $('.announcement-bar').height() : 0)
      }, {
        duration: 600,
        easing: "easeInOutQuad"
      });
    })

    .on('keydown', '[data-action=scroll]', function(e) {
      if(e.which == 13){
        e.preventDefault();
        window.location = $(this).attr('href');
      }
    })

    .on('click', '[data-action=load-more-collections][data-message]', function(e){
      e.preventDefault();
      
      var $this = $(this),
          $a = $('<a>').attr('class', $this.attr('class') + ' processing').html($this.attr('data-message')).prepend($('<i class="fc fc-cog fc-spin">'));

      $a.insertAfter($this)
      $this.hide();

      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: $this.attr('href'),
        success: function(data) {
          var $current_collections  = $('.collections .collection'),
              $new_collections = $(data).find('.collections .collection'),
              $new_pagination_button = $(data).find('[data-action=load-more-collections]');

          $new_collections.insertAfter($current_collections.last()).fadeTo(0,0).fadeTo(300, 1);
          $a.remove();
          if ($new_pagination_button.length){
            $this.attr('href', $new_pagination_button.attr('href')).show();
          } else {
            $this.parents('.pagination').remove();
          }
          $(document).trigger('products_rendered');
        }
      });
    })

    .on('click', '[data-action=load-more-products][data-message]', function(e){
      e.preventDefault();
      
      var $this = $(this),
          $pagination = $this.parents('.pagination');
          $a = $('<a>').attr('class', $this.attr('class') + ' processing').html($this.attr('data-message')).prepend($('<i class="fc fc-cog fc-spin">'));

      $a.insertAfter($this)
      $this.hide();

      $.ajax({
        type: 'GET',
        dataType: 'html',
        url: $this.attr('href'),
        success: function(data) {
          var $current_products  = $('.products .product'),
              $new_products = $(data).find('.products .product'),
              $new_pagination_button = $(data).find('[data-action=load-more-products]');

          $new_products.insertAfter($pagination).fadeTo(0,0).fadeTo(300, 1);
          $pagination.insertAfter($new_products.last());
          $a.remove();

          if ($new_pagination_button.length){
            $this
              .attr('href', $new_pagination_button
              .attr('href')).show();
          } else {
            $pagination.remove();
          }
          $(document).trigger('products_rendered');
        }
      });
    })

    .on('click', '[data-action=load-more-articles][data-message]', function(e){
      e.preventDefault();
      
      var $this = $(this),
          $a = $('<a>').attr('class', $this.attr('class') + ' processing').html($this.attr('data-message')).prepend($('<i class="fc fc-cog fc-spin">'));

      $a.insertAfter($this)
      $this.hide();

      $.ajax({
        type: 'GET',
        dataType: "html",
        url: $this.attr('href'),
        success: function(data) {
          var $current_articles  = $('.blog .post'),
              $new_articles = $(data).find('.blog .post'),
              $new_pagination_button = $(data).find('[data-action=load-more-articles]');

          $new_articles.insertAfter($current_articles.last()).fadeTo(0,0).fadeTo(300, 1);
          $a.remove();
          if ($new_pagination_button.length){
            $this.attr('href', $new_pagination_button.attr('href')).show();
          } else {
            $this.parents('.pagination').remove();
          }
        }
      });
    })

    .on('change', '[data-action=update]', function(){
      $('input.update').click();
    })

    .on('change', 'select[data-action=filter]', function(){
      window.parent.location.href = $(this).val();
    })

    .on('keydown', '.field_with_errors > input', function() {
      return $(this).parent().removeClass('field_with_errors');
    })

    .on('click', '[data-action=toggle-recover-password]', function(){
      $('#recover_password').toggle();
      $('#login').toggle();

      if($('#recover_password').is(':visible')){
        $('#recover_password input#recover-email').focus();
      } else {
        $('#login input#customer_email').focus();
      }
    })

    .on('keydown', 'body', function(e){
      var $body = $('body');
      if($body.hasClass('searching') && e.which === 27){
        $('[data-action=toggle-search]').first().click();
      }
      if($body.hasClass('browsing') && e.which === 27){
        $('[data-action=toggle-browse]').first().click();
      }
      if($body.hasClass('picking') && e.which === 27){
        $('[data-action=toggle-pick]').first().click();
      }
      $('[data-action=keydown][data-key][href]').each(function(){
        if(!$.magnificPopup.instance.isOpen && !$(':focus').is('model-viewer')){
          if(e.which === parseInt($(this).attr('data-key'))){
            $(this).addClass("hover");
            window.parent.location.href = $(this).attr('href');
          }
        }
      });
      if(e.which == 9){
        if($body.hasClass('no-outlines')){
          $body
            .removeClass('no-outlines')
            .one('mousedown', function(){
              $(this).addClass('no-outlines');
              // restore slideshows regular settings
              $('.slides').each(function(){
                if($(this).data('autoplay')){
                  $(this).slick('slickPlay');
                }
                $(this).slick('slickSetOption', 'focusOnChange', false, true);
              })
            });

          // set slideshow accesibility settings
          if($('.slides').length && $('.slides').hasClass('slick-initialized')) {
            $('.slides')
              .slick('slickPause')
              .slick('slickSetOption', 'focusOnChange', true);
          }
        }
      }

      if(e.which == 13){
        var $activeElement = $(document.activeElement);
        switch($activeElement.attr('data-action')){
          case 'toggle-cart':
            window.parent.location = California.routes.cart;
            e.preventDefault();
            break;
          case 'toggle-search':
            window.parent.location = California.routes.search;
            e.preventDefault();
            break;
          case 'show-product':
            window.parent.location = $activeElement.attr('href');
            e.preventDefault();
        }
      }
    })

    .on('keyup', 'body', function(e){
      var $body = $('body');

      if(e.which == 9){
        var $activeElement = $(document.activeElement);
        if(!$body.hasClass('browsing') && $activeElement.parents('.side-nav').length > 0){
          $('[data-action=toggle-browse]').first().click();
        }
        if ($body.hasClass('browsing') && $activeElement.parents('.side-nav').length == 0){
          $('[data-action=toggle-browse]').first().click();
        }
      }
    })

    .on('products_rendered', function(){
      $('.products .product img:not(.rendered)').each(function(){
        var image = new Image(),
            $image = $(this),
            $product = $image.parents('.product'),
            $line = $('.line', $product),
            width = $image.data('width');
            height = $image.data('height'),
            angle = -Math.round(Math.atan2(height, width) * 57.2957795, 2);

        $line
          .css('transform', 'rotate(' + angle + 'deg)')
          .css('-ms-transform', 'rotate(' + angle + 'deg)')
          .css('-moz-transform', 'rotate(' + angle + 'deg)')
          .css('-webkit-transform', 'rotate(' + angle + 'deg)')
          .css('-o-transform', 'rotate(' + angle + 'deg)');

        $image
          .addClass('rendered');

      });
      California.onPriceAdded();
    })


    .on('touchstart click', '.side-nav [data-action=link-to-child-list][data-handle]', function(e){
      var $this = $(this),
          handle = $this.attr('data-handle'),
          $li = $this.parents('li'),
          $list = $('.' + handle, $li);

      if(e.type == "click") e.preventDefault();
      if(is_touch_device && e.type == "click") return;
      if(!is_touch_device && e.type == "touchstart") return;

      if($list.length > 0){
        if($this.attr('aria-expanded') == "true") {
          $this.attr('aria-expanded', 'false');
        } else {
          $this.attr('aria-expanded', 'true');
        }
        $list.slideToggle(400, "easeOutQuad");
      }
    })

    .on((is_touch_device ? 'touchstart' : 'mouseenter') + ' click', '.hero-nav [data-action=link-to-child-list][data-handle]', function(e){
      var $this = $(this),
          handle = $this.attr('data-handle'),
          $nav = $this.parents('.nav'),
          $li = $this.parents('li'),
          $ul = $('ul.' + handle, $li);

      if(e.type == "click") e.preventDefault();
      if(is_touch_device && e.type == "click") return;

      var contract = function(){
        $ul.removeClass('expanded');
        $this.attr('aria-expanded', 'false');
        $(window).off('resize.submenu  scroll.submenu');
      };

      if($ul.length > 0){
        if(!$ul.hasClass('expanded')) {
          $('.hero-nav .expanded').parent('li').trigger('mouseleave');
          $ul.addClass('expanded');
          if($this.offset().left > $(window).outerWidth()/2) {
            $ul.addClass('right');
          }
          $this.attr('aria-expanded', 'true');
          $li.one('mouseleave', function(e){
            e.preventDefault();
            contract();
          });
          $(window).on('resize.submenu scroll.submenu', function(){
            contract();
          });
        } else if (e.type == "touchstart") {
          contract();
        }
      }
    })

    .on('click', '[data-action=back-to-previous-list]', function(e){
      California.showPreviousList();
      e.preventDefault();
    })

    .on('click', '[data-action=remove]', function(e){
      $(this).addClass('click-disabled');
    })
    .on('click', '.click-disabled', function(e){
      e.preventDefault();
    })
    .on('click', '[data-action=show-landing]', function(e){
      e.preventDefault();
      $('.landing').fadeIn();
      $('.login').hide();
      $('[data-action=show-login]').removeClass('hide');
      $('[data-action=show-landing]').addClass('hide');
    })
    .on('click', '[data-action=show-login]', function(e){
      e.preventDefault();
      $('.landing').hide();
      $('.login').fadeIn();
      if(!window.is_touch_device){
        $('.login input.email').focus();
      }
      $('[data-action=show-login]').addClass('hide');
      $('[data-action=show-landing]').removeClass('hide');
    })

    .on('click', 'a[href="#"]', function(e){
      e.preventDefault();
    });

    if(window.show_password_login){
      $('[data-action=show-login]').first().trigger('click');
    }
};

California.openSideNav = function() {
  var $body = $('body');
  if($body.hasClass('searching')){
    $('[data-action=toggle-search]').first().click();
  };
  $body.addClass('browsing');
  $('.header-nav [data-action=toggle-browse]').addClass('active');
};

California.closeSideNav = function() {
  $('body').removeClass('browsing');
  $('.header-nav [data-action=toggle-browse]').removeClass('active');
};

California.openSidePick = function() {
  var $body = $('body');
  if($body.hasClass('searching')){
    $('[data-action=toggle-search]').first().click();
  };
  $body.addClass('picking');
};

California.closeSidePick = function() {
  $('body').removeClass('picking');
};

California.initHomepage = function(){
  if($('.template-index').length) {
    if($('.announcement-bar').length) {
      if($('.hero.height_100').length) {
        var hero_height = $('.hero.height_100').height(),
            announcemnt_height = $('.announcement-bar').height(),
            height = (hero_height - announcemnt_height);
        $('.hero.height_100').css('height', height + "px");
      }
    }
  }
};

California.initSections = function(){
  var sections = new California.Sections();
  sections.register('hero', California.Hero);
  sections.register('featured-collection', California.FeaturedCollection);
  sections.register('product', California.Product);
  sections.register('product-recommendations', California.ProductRecommendations);
  sections.register('side-nav', California.SideNav);
  sections.register('map', California.Map);
  sections.register('footer', California.Footer);
};

California.initLoginPage = function(){
  // direct access to recover page: account/login#recover
  if (window.parent.location.hash == '#recover'){ 
    $('[data-action=toggle-recover-password]').first().click();
  }
};

California.initAddressesPage = function(){
  var $body = $('body');

  if ($body.hasClass('template-customers-addresses') && window.customer_addresses){
    // Initialize observers on address selectors
    new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {
      hideElement: 'address_province_container_new'
    });

    // Setup province selector on each customer address
    for(var i in window.customer_addresses){
      var id = window.customer_addresses[i];
      new Shopify.CountryProvinceSelector('address_country_' + id, 'address_province_' + id, {
        hideElement: 'address_province_container_' + id
      });
    }

    // Contents of customer_area.js (global asset)
    Shopify.CustomerAddress = {
      toggleForm: function(id) {
        var $form = $('#edit_address_' + id),
            $button = $('#view_address_' + id);
        
        $form.toggle();
        $button.toggle();

        if ($form.is(':visible')){
          $('input:not([type=hidden])', $form).first().focus()
          $('body,html').animate({ scrollTop: $form.offset().top}, { duration: 600 });
        }

        return false;
      },

      toggleNewForm: function() {
        var $form = $('#add_address'),
            $button = $('#add_new_address_button');

        $form.toggle();
        $button.toggle();

        if ($form.is(':visible')){
          $('input:not([type=hidden])', $form).first().focus()
          $('body,html').animate({ scrollTop: $form.offset().top}, { duration: 600 });
        }
        return false;
      },

      destroy: function(id, confirm_msg) {
        if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
          Shopify.postLink(California.routes.account_addresses + '/' + id, {'parameters': {'_method': 'delete'}});
        }
      }
    }
  }
};

California.initSearchPage = function(){
  var $body = $('body');

  if ($body.hasClass('template-search')){
    $(document)    
      .on('submit', 'form.search-bar', function(e){
        var $form = $(this);
        $.ajax({
           type: 'POST',
           dataType: 'html',
           url: $form.attr('action'),
           data: $form.serialize(),
           success: function(data){
            $('.main-content').replaceWith($(data).find('.main-content'));
            $(document).trigger('products_rendered');
           }
         });
        e.preventDefault();
      });
  }

  $(document)
    .on('click', "a[href$='/search']:not([data-action])", function(e){
      e.preventDefault();
      $('body,html').animate({ scrollTop: 0}, { duration: 0 });
      $('[data-action=toggle-search]').first().click();
    });
};

California.initFooter = function() {
  $('.footer [href="https://www.shopify.com"]').attr('href', "https://www.shopify.com?ref=guille-lopez");
};

California.initNewsletter = function() {
  if (location.search.indexOf('customer_posted=true') !== -1 || location.search.indexOf('contact%5Bemail%5D=') !== -1){
    setTimeout(function(){
      var offsetTop = 0;
      if($('.newsletter-section').length){
        offsetTop = $('.newsletter-section').offset().top;
      } else {
        offsetTop = $('.footer').offset().top;
      }

      $('body,html').animate({ scrollTop: offsetTop}, { duration: 0 });
    }, 1000);
  }
};

California.initIE = function(){
  // add ie class
  if (window.is_ie) {
    $("html").addClass("ie");
  }
};

California.initEasings = function(){
  var baseEasings = {};

  $.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
    baseEasings[ name ] = function( p ) {
      return Math.pow( p, i + 2 );
    };
  });

  $.extend( baseEasings, {
    Sine: function( p ) {
      return 1 - Math.cos( p * Math.PI / 2 );
    },
    Circ: function( p ) {
      return 1 - Math.sqrt( 1 - p * p );
    },
    Elastic: function( p ) {
      return p === 0 || p === 1 ? p :
        -Math.pow( 2, 8 * (p - 1) ) * Math.sin( ( (p - 1) * 80 - 7.5 ) * Math.PI / 15 );
    },
    Back: function( p ) {
      return p * p * ( 3 * p - 2 );
    },
    Bounce: function( p ) {
      var pow2,
        bounce = 4;

      while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
      return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
    }
  });

  $.each( baseEasings, function( name, easeIn ) {
    $.easing[ "easeIn" + name ] = easeIn;
    $.easing[ "easeOut" + name ] = function( p ) {
      return 1 - easeIn( 1 - p );
    };
    $.easing[ "easeInOut" + name ] = function( p ) {
      return p < 0.5 ?
        easeIn( p * 2 ) / 2 :
        1 - easeIn( p * -2 + 2 ) / 2;
    };
  });
};

California.onPriceAdded = function(){
  if(window.Currency){
    Currency.convertAll(shopCurrency, $('[name=currencies]').val());
    onCurrencySet();
  }
};